import useReveal from '../hooks/useReveal';
import { PRODUCTS, TESTIMONIALS, PROCESS_STEPS, STATS, WHY_US } from '../data/data';

export default function HomePage({ setPage }) {
  useReveal();
  const go = (id) => { setPage(id); window.scrollTo(0, 0); };

  return (
    <div>

      {/* ══════════════════════════════════════════
          HERO — full-bleed split with real photo
      ══════════════════════════════════════════ */}
      <section style={{ display:'grid', minHeight:'calc(100vh - 114px)', overflow:'hidden' }} className="hero-grid">

        {/* Left — text */}
        <div style={{ padding:'80px 6vw 80px 7vw', background:'var(--cream)', display:'flex', flexDirection:'column', justifyContent:'center', position:'relative' }}>
          <div style={{ position:'absolute', left:0, top:'20%', bottom:'20%', width:5, background:'linear-gradient(to bottom, transparent, var(--orange), transparent)', borderRadius:3 }} />
          <div style={{ animation:'fadeUp .8s ease both' }}>
            <div className="tag-line">Hyderabad's Trusted B2B Partner</div>
            <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:'clamp(2.3rem,4.2vw,4rem)', fontWeight:800, color:'var(--dark)', lineHeight:1.1, marginBottom:22 }}>
              Fresh Groceries<br/>
              <em style={{ color:'var(--orange)', fontStyle:'italic' }}>Delivered</em> to<br/>
              Your Kirana Shop
            </h1>
            <p style={{ fontSize:'1.05rem', lineHeight:1.9, color:'var(--text-mid)', marginBottom:36, maxWidth:470 }}>
              SLN E SHOP TRADERS supplies rice, oil, dal, spices and 200+ daily essentials directly to kirana stores, restaurants and provision shops — at <strong>wholesale prices</strong>, with <strong>same-day delivery</strong> across Hyderabad.
            </p>
            <div style={{ display:'flex', gap:14, flexWrap:'wrap', marginBottom:44 }}>
              <button className="btn-primary" style={{ fontSize:'1rem', padding:'15px 36px' }} onClick={()=>go('contact')}>Get a Free Quote</button>
              <button className="btn-outline" style={{ fontSize:'1rem' }} onClick={()=>go('delivery')}>How We Deliver →</button>
            </div>
            <div style={{ display:'flex', gap:0, flexWrap:'wrap', borderTop:'1px solid var(--border)', paddingTop:24 }}>
              {STATS.map((s,i)=>(
                <div key={i} style={{ flex:'1 1 100px', textAlign:'center', padding:'0 12px', borderRight: i<3?'1px solid var(--border)':'none' }}>
                  <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.8rem', fontWeight:800, color:'var(--orange)', lineHeight:1 }}>{s.n}</div>
                  <div style={{ fontSize:'.72rem', color:'var(--text-light)', fontWeight:600, marginTop:4, lineHeight:1.4 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right — real photo with overlay */}
        <div style={{ position:'relative', overflow:'hidden', minHeight:500 }}>
          <img
            src="https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=1000&q=85&fit=crop"
            alt="Grocery delivery to kirana shop"
            style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }}
          />
          {/* Gradient overlay */}
          <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, rgba(26,15,5,0.72) 0%, rgba(232,97,10,0.45) 100%)' }} />
          {/* Content over photo */}
          <div style={{ position:'relative', zIndex:2, height:'100%', display:'flex', flexDirection:'column', justifyContent:'flex-end', padding:'48px 44px' }}>
            <div style={{ background:'rgba(255,255,255,0.12)', backdropFilter:'blur(12px)', border:'1px solid rgba(255,255,255,.22)', borderRadius:12, padding:'24px 28px', animation:'fadeUp .8s .3s ease both' }}>
              <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
                <img src="/logo.png" alt="SLN E SHOP TRADERS" style={{ height:40, filter:'brightness(10)' }} />
                <div>
                  <div style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, color:'#fff', fontSize:'1.1rem' }}>SLN E SHOP TRADERS</div>
                  <div style={{ fontSize:'.7rem', color:'rgba(255,255,255,.7)' }}>B2B Wholesale Delivery · Hyderabad</div>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                {['✅ GST Invoice on Every Order','🚐 Same-Day Delivery','💰 Wholesale Rates — No Middlemen','📱 Order via WhatsApp or Call'].map((f,i)=>(
                  <div key={i} style={{ display:'flex', alignItems:'center', gap:8, fontSize:'.82rem', color:'rgba(255,255,255,.9)', fontWeight:500 }}>{f}</div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <style>{`.hero-grid{grid-template-columns:1fr 1fr;} @media(max-width:860px){.hero-grid{grid-template-columns:1fr!important;} .hero-grid>div:last-child{min-height:380px!important;}}`}</style>
      </section>

      {/* ══════════════════════════════════════════
          WHY CHOOSE US — Photo cards (no icons)
      ══════════════════════════════════════════ */}
      <section style={{ padding:'100px 5vw', background:'#fff' }}>
        <div className="container">
          <div style={{ textAlign:'center', marginBottom:64 }} className="reveal">
            <div className="tag-line" style={{ justifyContent:'center' }}>Why Choose SLN E SHOP TRADERS</div>
            <h2 className="section-title" style={{ textAlign:'center', margin:'0 auto 14px' }}>
              The Smarter Way to <em>Stock Your Shop</em>
            </h2>
            <p className="section-sub" style={{ textAlign:'center', margin:'0 auto' }}>
              Stop wasting hours at the mandi every morning. Let us bring everything to your doorstep.
            </p>
          </div>

          <div style={{ display:'grid', gap:28 }} className="why-grid">
            {WHY_US.map((card,i)=>(
              <div key={i} className="reveal" style={{ borderRadius:12, overflow:'hidden', border:'1px solid var(--border)', background:'#fff', boxShadow:'var(--shadow-sm)', transition:'transform .3s, box-shadow .3s', animationDelay:`${i*.08}s` }}
                onMouseEnter={e=>{ e.currentTarget.style.transform='translateY(-6px)'; e.currentTarget.style.boxShadow='var(--shadow-lg)'; }}
                onMouseLeave={e=>{ e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='var(--shadow-sm)'; }}>
                {/* Photo */}
                <div style={{ position:'relative', height:200, overflow:'hidden' }}>
                  <img src={card.photo} alt={card.title} style={{ width:'100%', height:'100%', objectFit:'cover', transition:'transform .4s' }}
                    onMouseEnter={e=>e.target.style.transform='scale(1.06)'}
                    onMouseLeave={e=>e.target.style.transform='scale(1)'}
                  />
                  <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(26,15,5,.55) 0%, transparent 60%)' }} />
                  <span style={{ position:'absolute', bottom:14, left:14, background:'var(--orange)', color:'#fff', fontSize:'.7rem', fontWeight:700, padding:'4px 12px', borderRadius:20, letterSpacing:'.04em' }}>
                    {card.tag}
                  </span>
                </div>
                {/* Text */}
                <div style={{ padding:'22px 24px 28px' }}>
                  <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.1rem', fontWeight:700, color:'var(--dark)', marginBottom:10 }}>{card.title}</h3>
                  <p style={{ fontSize:'.88rem', lineHeight:1.85, color:'var(--text-mid)' }}>{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <style>{`.why-grid{grid-template-columns:repeat(3,1fr);} @media(max-width:960px){.why-grid{grid-template-columns:repeat(2,1fr)!important;}} @media(max-width:580px){.why-grid{grid-template-columns:1fr!important;}}`}</style>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          FEATURED PRODUCTS — real photos
      ══════════════════════════════════════════ */}
      <section style={{ padding:'100px 5vw', background:'var(--cream)' }}>
        <div className="container">
          <div style={{ display:'flex', alignItems:'flex-end', justifyContent:'space-between', marginBottom:52, flexWrap:'wrap', gap:20 }}>
            <div className="reveal">
              <div className="tag-line">Our Products</div>
              <h2 className="section-title">What We Supply</h2>
            </div>
            <button className="btn-outline reveal" onClick={()=>go('products')}>View All Products →</button>
          </div>
          <div style={{ display:'grid', gap:24 }} className="home-prod-grid">
            {PRODUCTS.slice(0,4).map((p,i)=>(
              <div key={p.id} className="product-card reveal" style={{ animationDelay:`${i*.1}s` }}>
                <div style={{ height:180, overflow:'hidden', position:'relative' }}>
                  <img src={p.photo} alt={p.name} style={{ width:'100%', height:'100%', objectFit:'cover', transition:'transform .4s' }}
                    onMouseEnter={e=>e.target.style.transform='scale(1.07)'}
                    onMouseLeave={e=>e.target.style.transform='scale(1)'}
                  />
                  <span style={{ position:'absolute', top:12, right:12, background:'rgba(255,255,255,.92)', borderRadius:4, padding:'2px 10px', fontSize:'.68rem', fontWeight:700, color:p.accent, textTransform:'uppercase', letterSpacing:'.05em' }}>{p.category}</span>
                </div>
                <div style={{ padding:'20px 22px 26px' }}>
                  <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.08rem', fontWeight:700, color:'var(--dark)', marginBottom:8 }}>{p.name}</h3>
                  <p style={{ fontSize:'.83rem', color:'var(--text-light)', lineHeight:1.75, marginBottom:14 }}>{p.desc.slice(0,88)}…</p>
                  <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:16 }}>
                    {p.sizes.map((s,j)=>(<span key={j} style={{ fontSize:'.7rem', background:'var(--cream-dark)', color:'var(--text-mid)', padding:'3px 10px', borderRadius:20, fontWeight:600 }}>{s}</span>))}
                  </div>
                  <button style={{ background:'none', border:'none', cursor:'pointer', fontSize:'.82rem', fontWeight:700, color:'var(--orange)', padding:0, fontFamily:"'DM Sans',sans-serif" }} onClick={()=>go('contact')}>Get Quote →</button>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign:'center', marginTop:44 }} className="reveal">
            <button className="btn-primary" onClick={()=>go('products')}>View All 200+ Products →</button>
          </div>
          <style>{`.home-prod-grid{grid-template-columns:repeat(4,1fr);} @media(max-width:1000px){.home-prod-grid{grid-template-columns:repeat(2,1fr)!important;}} @media(max-width:560px){.home-prod-grid{grid-template-columns:1fr!important;}}`}</style>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          DELIVERY TEASER — dark with photo bg
      ══════════════════════════════════════════ */}
      <section style={{ padding:'100px 5vw', position:'relative', overflow:'hidden', background:'#1A0F05' }}>
        {/* Background photo */}
        <div style={{ position:'absolute', inset:0, zIndex:0 }}>
          <img src="https://images.unsplash.com/photo-1553413077-190dd305871c?w=1400&q=80&fit=crop" alt="warehouse" style={{ width:'100%', height:'100%', objectFit:'cover', opacity:.18 }} />
        </div>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, rgba(26,15,5,0.92) 0%, rgba(232,97,10,0.25) 100%)', zIndex:1 }} />

        <div className="container" style={{ position:'relative', zIndex:2 }}>
          <div style={{ textAlign:'center', marginBottom:64 }} className="reveal">
            <div className="tag-line" style={{ justifyContent:'center', color:'var(--orange-light)' }}>How It Works</div>
            <h2 className="section-title section-title-white" style={{ textAlign:'center', margin:'0 auto 16px' }}>
              From WhatsApp to <em style={{ color:'var(--orange-light)' }}>Your Shop Door</em>
            </h2>
            <p style={{ color:'rgba(255,255,255,.58)', fontSize:'.97rem', maxWidth:520, margin:'0 auto' }}>
              Our simple 4-step process ensures fresh products reach your shop quickly and correctly, every single time.
            </p>
          </div>

          <div style={{ display:'grid', gap:24 }} className="steps-photo-grid">
            {PROCESS_STEPS.map((step,i)=>(
              <div key={i} className="reveal" style={{ borderRadius:12, overflow:'hidden', border:'1px solid rgba(255,255,255,.12)', background:'rgba(255,255,255,.07)', backdropFilter:'blur(8px)', animationDelay:`${i*.1}s`, transition:'transform .3s', cursor:'pointer' }}
                onMouseEnter={e=>e.currentTarget.style.transform='translateY(-4px)'}
                onMouseLeave={e=>e.currentTarget.style.transform=''}>
                <div style={{ height:160, overflow:'hidden', position:'relative' }}>
                  <img src={step.photo} alt={step.title} style={{ width:'100%', height:'100%', objectFit:'cover', opacity:.75 }} />
                  <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(26,15,5,.8) 0%, transparent 50%)' }} />
                  <div style={{ position:'absolute', top:14, left:14, width:36, height:36, borderRadius:'50%', background:'var(--orange)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Playfair Display',serif", fontWeight:800, color:'#fff', fontSize:'.9rem' }}>{i+1}</div>
                </div>
                <div style={{ padding:'18px 20px 22px' }}>
                  <div style={{ fontSize:'.68rem', fontWeight:700, color:'var(--orange-light)', letterSpacing:'.1em', marginBottom:6 }}>STEP {step.num}</div>
                  <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'.98rem', fontWeight:700, color:'#fff', marginBottom:6 }}>{step.title}</h3>
                  <p style={{ fontSize:'.8rem', color:'rgba(255,255,255,.55)', lineHeight:1.65 }}>{step.sub}</p>
                </div>
              </div>
            ))}
          </div>
          <style>{`.steps-photo-grid{grid-template-columns:repeat(4,1fr);} @media(max-width:900px){.steps-photo-grid{grid-template-columns:repeat(2,1fr)!important;}} @media(max-width:500px){.steps-photo-grid{grid-template-columns:1fr!important;}}`}</style>

          <div style={{ textAlign:'center', marginTop:52 }} className="reveal">
            <button className="btn-primary" style={{ fontSize:'1rem', padding:'15px 36px' }} onClick={()=>go('delivery')}>See Full Delivery Process →</button>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          TESTIMONIALS
      ══════════════════════════════════════════ */}
      <section style={{ padding:'100px 5vw', background:'#fff' }}>
        <div className="container">
          <div style={{ textAlign:'center', marginBottom:56 }} className="reveal">
            <div className="tag-line" style={{ justifyContent:'center' }}>Customer Stories</div>
            <h2 className="section-title" style={{ textAlign:'center', margin:'0 auto 12px' }}>What Our Customers <em>Say</em></h2>
          </div>
          <div style={{ display:'grid', gap:22 }} className="testi-grid">
            {TESTIMONIALS.slice(0,4).map((t,i)=>(
              <div key={i} className="reveal" style={{ background:'var(--cream)', border:'1px solid var(--border)', borderRadius:12, padding:'28px 26px', transition:'transform .3s, box-shadow .3s', animationDelay:`${i*.1}s` }}
                onMouseEnter={e=>{ e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='var(--shadow-md)'; }}
                onMouseLeave={e=>{ e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow=''; }}>
                <div style={{ color:'var(--orange)', fontSize:'1rem', marginBottom:14, letterSpacing:2 }}>{'★'.repeat(t.stars)}</div>
                <p style={{ fontSize:'.93rem', lineHeight:1.88, color:'var(--text-mid)', fontStyle:'italic', marginBottom:22, borderLeft:'3px solid var(--orange-pale)', paddingLeft:16 }}>"{t.text}"</p>
                <div style={{ display:'flex', alignItems:'center', gap:14 }}>
                  <div style={{ width:46, height:46, background:'linear-gradient(135deg, var(--orange), var(--orange-light))', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.85rem', fontWeight:700, color:'#fff', flexShrink:0 }}>{t.initials}</div>
                  <div>
                    <div style={{ fontFamily:"'Playfair Display',serif", fontWeight:600, color:'var(--dark)', fontSize:'.93rem' }}>{t.name}</div>
                    <div style={{ fontSize:'.75rem', color:'var(--text-light)' }}>{t.biz}</div>
                    <div style={{ fontSize:'.7rem', color:'var(--orange)', fontWeight:600, marginTop:2 }}>{t.since}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <style>{`.testi-grid{grid-template-columns:repeat(2,1fr)!important;} @media(max-width:700px){.testi-grid{grid-template-columns:1fr!important;}}`}</style>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          FINAL CTA BAND
      ══════════════════════════════════════════ */}
      <section style={{ padding:'88px 5vw', position:'relative', overflow:'hidden', background:'#1A0F05', textAlign:'center' }}>
        <div style={{ position:'absolute', inset:0 }}>
          <img src="https://images.unsplash.com/photo-1586201375761-83865001e31c?w=1400&q=80&fit=crop" alt="rice" style={{ width:'100%', height:'100%', objectFit:'cover', opacity:.12 }} />
        </div>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, rgba(232,97,10,0.6) 0%, rgba(26,15,5,0.9) 100%)' }} />
        <div className="container" style={{ position:'relative', zIndex:2 }}>
          <div className="reveal">
            <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:'clamp(1.9rem,3.5vw,2.9rem)', fontWeight:800, color:'#fff', marginBottom:14 }}>
              Ready to Stock Smarter?
            </h2>
            <p style={{ fontSize:'1.05rem', color:'rgba(255,255,255,.85)', maxWidth:520, margin:'0 auto 36px', lineHeight:1.8 }}>
              Join 500+ Hyderabad kirana stores getting fresh products, genuine wholesale rates and on-time delivery every day.
            </p>
            <div style={{ display:'flex', gap:16, justifyContent:'center', flexWrap:'wrap' }}>
              <button className="btn-white" onClick={()=>go('contact')}>Get a Free Quote Today</button>
              <a href="https://wa.me/919121927878" target="_blank" rel="noopener noreferrer" className="btn-outline-white">💬 WhatsApp Us</a>
            </div>
            <div style={{ marginTop:28, display:'flex', gap:24, justifyContent:'center', flexWrap:'wrap' }}>
              {['✓ Free Registration','✓ No Advance Payment','✓ GST Invoice Always','✓ Cancel Anytime'].map((f,i)=>(
                <span key={i} style={{ fontSize:'.82rem', color:'rgba(255,255,255,.75)', fontWeight:500 }}>{f}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
